"use client";

import SectionQualityOrigins from "./sections/SectionQualityOrigins";
import SectionRecipeComparison from "./sections/SectionRecipeComparison";
import SectionSuccessStories from "./sections/SectionSuccessStories";
import SectionExpertBacked from "./sections/SectionExpertBacked";
import SectionHowItWorks from "./sections/SectionHowItWorks";
import SectionFreeTrial from "./sections/SectionFreeTrial";
import SectionFoundersMessage from "./sections/SectionFoundersMessage";
import SectionFAQ from "./sections/SectionFAQ";
import SectionTastyTestimonials from "./sections/SectionTastyTestimonials";
import LandingPageSticky from "./LandingPageSticky";
import SectionIncredibleHealthBenefits from "./sections/SectionIncredibleHealthBenefits";
import SectionCatsAreCarnivores from "./sections/SectionCatsAreCarnivores";

export default function LandingPageBody() {

  return (
    <div className="flex flex-col">
      { /* Section 1: Quality Origins */ }
      <SectionQualityOrigins />

      <LandingPageSticky />

      { /* Section 2: Cats are carnivores */ }
      <SectionCatsAreCarnivores />

      { /* Section 3: Recipe Comparison */ }
      <SectionRecipeComparison />

      { /* Section 4: Incredible Health Benefits */ }
      <SectionIncredibleHealthBenefits />

      { /* Section 5: Success Stories */ }
      <SectionSuccessStories />

      { /* Section 6: Expert Backed */ }
      <SectionExpertBacked />

      { /* Section 7: Tasty Testimonials */ }
      <SectionTastyTestimonials />

      { /* Section 8: How It Works */ }
      <SectionHowItWorks />

      { /* Section 9: Free Trial */ }
      <SectionFreeTrial />

      { /* Section 10: Founders Message */ }
      <SectionFoundersMessage />

      { /* Section 11: FAQ */ }
      <SectionFAQ />
    </div>
  );
}
